import React from 'react';
import { PhoneLink, PhoneLinksContainer } from '../styled';
import {
  formatAzerbaijanPhone,
  phoneWithInternationalCode
} from '../../../../utils/helpers/common';
import CallPhoneIcon from '../../../../public/static/images/phone_call_brown-icon.svg';
import Icon from '../../../Icon';

interface PhoneLinksListProps {
  phones: string[] | null;
  isGallery?: boolean;
  showIcon?: boolean;
}

export const PhoneLinksList: React.FC<PhoneLinksListProps> = ({
  phones,
  isGallery = false,
  showIcon = false
}) => {
  const onPhoneLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    phone: string
  ) => {
    e.stopPropagation();
    window.open(`tel:${phoneWithInternationalCode(phone)}`, '_top');
  };

  if (!phones) return null;

  return (
    <PhoneLinksContainer>
      {phones.map(phone => (
        <PhoneLink
          key={phone}
          href={`tel:${phoneWithInternationalCode(phone)}`}
          $isGallery={isGallery}
          onClick={e => onPhoneLinkClick(e, phone)}
        >
          {showIcon && (
            <Icon
              width={18}
              height={18}
              IconComponent={CallPhoneIcon}
              indent={false}
            />
          )}
          {formatAzerbaijanPhone(phoneWithInternationalCode(phone))}
        </PhoneLink>
      ))}
    </PhoneLinksContainer>
  );
};
